import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
// import { getFirestore, provideFirestore } from '@angular/fire/firestore';
// import { getAuth, provideAuth } from '@angular/fire/auth';
// import { provideStorage, getStorage } from '@angular/fire/storage';

@NgModule({
  declarations: [],
})
export class FirebaseModule {
  // public static forRoot(environment: any) {
  //   return {
  //     ngModule: FirebaseModule,
  //     imports: [CommonModule],
  //     providers: [
  //       provideFirebaseApp(() => initializeApp(environment.firebase)),
  //       provideFirestore(() => getFirestore()), // only needed for database features
  //       provideAuth(() => getAuth()), // only needed for auth features,
  //       provideStorage(() => getStorage()), // only needed for storage features
  //     ],
  //   };
  // }
}
